import { LinkedInError } from './errors';

/**
 * Exchange a LinkedIn authorization code for an access token.
 *
 * SECURITY: this exchange requires the confidential client secret and therefore
 * cannot be performed in the browser. The previous implementation shipped the
 * secret in the bundle and relayed it through a third-party public CORS proxy
 * (api.allorigins.win), handing both the secret and the user's authorization
 * code to an unrelated operator.
 *
 * The exchange must be performed by a trusted server-side endpoint that holds
 * the secret. Until that endpoint exists, this function fails closed.
 */
export async function exchangeCodeForToken(_code: string): Promise<string> {
  throw new LinkedInError(
    'TOKEN_ERROR',
    "La connexion LinkedIn est momentanément indisponible."
  );
}
